import { render } from "./SendHistComponent.vue?vue&type=template&id=ae9345fe"
import script from "./SendHistComponent.vue?vue&type=script&lang=js"
export * from "./SendHistComponent.vue?vue&type=script&lang=js"

import "./SendHistComponent.vue?vue&type=style&index=0&id=ae9345fe&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__